import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-new-customer-biller-from-empty-cart-timeout-dialog',
  templateUrl: './new-customer-biller-from-empty-cart-timeout-dialog.component.html',
  styleUrls: ['./new-customer-biller-from-empty-cart-timeout-dialog.component.css'],
})
export class NewCustomerBillerFromEmptyCartTimeoutDialogComponent {

  constructor() {
  }
}
